$(document).ready(function(){
    var backButtons = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/slider-img-left.png?v=1742583730" alt=""></span>';
    var nextButtons = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/slider-img-right.png?v=1742583730" alt=""></span>'
    $('.double-carousel-products-row-wrapper').slick({
      dots: false,
      infinite: false,
      arrows: true,
    prevArrow: backButtons,
    nextArrow: nextButtons,
      speed: 300, 
      slidesToShow: 3.9,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600, 
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.4,
            infinite: false, 
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });


     var backbtn = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/white-arrow-left.png?v=1742589021" alt=""></span>';
    var nextbtn = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/white-arrow-right.png?v=1742589021" alt=""></span>'
    $('.double-carousel-collection-row').slick({
      dots: false,
      infinite: false,
      arrows: true, 
    prevArrow: backbtn,
    nextArrow: nextbtn,
      speed: 300, 
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1020, 
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    var backButtonss = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/slider-img-left.png?v=1742583730" alt=""></span>';
    var nextButtonss = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/slider-img-right.png?v=1742583730" alt=""></span>'
    $('.multi-categories-carousel-wrapper').slick({
      dots: false,
      infinite: false,
      arrows: true,
    prevArrow: backButtonss,
    nextArrow: nextButtonss,
      speed: 300,
      slidesToShow: 3.9,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600, 
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.4,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    $('.collection-single__tab').click(function(){
      $('.multi-categories-carousel-wrapper').slick('refresh');
    })


    var backButtonsss = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/Vector_1.png?v=1742586767" alt=""></span>';
    var nextButtonsss = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/Vector_2.png?v=1742586767" alt=""></span>'
    $('.testimonial-carousel').slick({
      dots: false,
      infinite: false, 
      arrows: true,
    prevArrow: backButtonsss,
    nextArrow: nextButtonsss,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1026,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600, 
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });


    $('.image-grid-carousel-wrapper').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      centerMode: true,
      variableWidth: true
    });

    document.getElementById("togglePassword").addEventListener("click", function() {
      let passwordInput = document.getElementById("CustomerPassword");
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    });
    
});

$('.tab').on('click', function(evt) {
  evt.preventDefault();
  $('.tab').removeClass('active');
  $(this).addClass('active');
  var sel = this.getAttribute('data-toggle-target');
  $('.tab-content').removeClass('active').filter(sel).addClass('active');
});

$('.footer-block__details-content li p').click(function() {
  $(this).toggleClass('active');
  $(this).next('.footer-contact__column-sub__wrapper').toggleClass('active');
  $(this).next('.footer-dynamic__column-sub__wrapper').toggleClass('active');
});

// Select the element to observe
const targetNode = document.querySelector('product-recommendations');

// Options for the observer (which mutations to observe)
const config = { attributes: true, attributeFilter: ['class'] };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      console.log('The class attribute was modified:', mutation.target.classList);
var backButtonssss = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/slider-img-left.png?v=1742583730" alt="" /></span>';
    var nextButtonssss = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0708/3399/5811/files/slider-img-right.png?v=1742583730" alt="" /></span>'
      // Perform actions based on the class change
      $('.related-product-slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      prevArrow: backButtonssss,
      nextArrow: nextButtonssss,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 41,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.6,
            slidesToScroll: 1
          }
        }
      ]
});
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

// To stop observing
// observer.disconnect();

$(document).ready(function(){
  $('.js-accessory-check').on("change", function(e) {
    var variant_id = $(this).closest(".accessories-item").find(".js-accessory-id");
    var qty = $(this).closest(".accessories-item").find(".js-accessory-qty");
    var form_id = $(this).data('form');
    if($(this).is(":checked")) {
      variant_id.attr("form",form_id);
      qty.attr("form",form_id);
    } else {
      variant_id.removeAttr('form');
      qty.removeAttr('form');
    }
  })
})




document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('recent-products-container');
  if (!container) return;

  const handles = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
  if (handles.length === 0) return;

  // Fetch each product via Shopify's JSON API
  handles.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        const productHTML = `
          <a href="${product.url}" class="recent-product">
            <img src="${product.images[0]}" alt="${product.title}" style="width: 100px;" />
            <p>${product.title}</p>
          </a>
        `;
        container.innerHTML += productHTML;
      })
      .catch(error => console.error('Error fetching product:', error));
  });
});

